__turbopack_context__.v({
  "carouselContainer": "style-module-scss-module__OfyRqG__carouselContainer",
  "centerAlign": "style-module-scss-module__OfyRqG__centerAlign",
  "hasLink": "style-module-scss-module__OfyRqG__hasLink",
  "imageContainer": "style-module-scss-module__OfyRqG__imageContainer",
  "interactiveLink": "style-module-scss-module__OfyRqG__interactiveLink",
  "labelContainer": "style-module-scss-module__OfyRqG__labelContainer",
  "leftAlign": "style-module-scss-module__OfyRqG__leftAlign",
  "slideContainer": "style-module-scss-module__OfyRqG__slideContainer",
  "videoTextContent": "style-module-scss-module__OfyRqG__videoTextContent",
});
